import React from 'react';
import { useTranslation } from "react-i18next";
import {Link} from 'react-router-dom'

import PageTitle from "../../components/Commons/PageTitle";
import AccountsList from "../../components/Accounts/AccountsList";

function Accounts() {
    const { t } = useTranslation();
    return (

        <div className="container container--larger">
			<div className="row ml-sm-auto justify-content-sm-between">
            	<PageTitle title={t('breadcrumbs.accounts')}/>
				<Link to='/tanks' className='btn btn--outline align-self-end'>{t('header.navigation.tanks')}</Link>
			</div>
            <AccountsList isSummary={false} />
        </div>
    );
}

export default Accounts;

